import React from "react";
import * as styles from "./Modal.module.scss";
import { Modal } from "react-bootstrap";
import classNames from "classnames";
import PropTypes from "prop-types";

const ModalOverlay = ({
	show = false,
	onHide,
	onExited,
	header,
	subheader,
	children,
	buttons,
	hasCloseButton = false,
	size = "lg",
	fullscreen,
	className,
}) => {
	const modalClassName = classNames(
		{
			[styles["modal"]]: true,
			[styles["modal--fullscreen"]]: fullscreen,
			["arbeitsplatzbesichtigung"]: true,
		},
		className,
	);

	return (
		<Modal
			className={modalClassName}
			centered
			show={show}
			fullscreen={fullscreen}
			onHide={onHide}
			onExited={onExited}
			backdrop={!fullscreen}
			size={size}
		>
			<Modal.Header className={styles["only-close"]} closeButton={hasCloseButton || fullscreen}>
				<div className={styles["header"]}>{header}</div>
				{subheader && (
					<div className={styles["subheader"]}>
						{subheader?.icon && <img src={subheader?.icon} alt={subheader?.text} />} {subheader?.text}
					</div>
				)}
			</Modal.Header>
			<Modal.Body>{children}</Modal.Body>
			{buttons && <div className={styles["buttons"]}>{buttons}</div>}
		</Modal>
	);
};

ModalOverlay.propTypes = {
	show: PropTypes.bool.isRequired,
	header: PropTypes.string,
	children: PropTypes.node.isRequired,
	buttons: PropTypes.node,
	hasCloseButton: PropTypes.bool,
	size: PropTypes.string,
	onHide: PropTypes.func,
	onExited: PropTypes.func,
};

export default ModalOverlay;
